import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import navigations from './views/form/navigations.vue'
import tabbar from './views/form/tabbar.vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Home from './views/index.vue'
import Index from './views/index.vue'
import IndexH5 from './views/indexH5.vue'
import About from './views/about.vue'
import Enterprise from './views/enterprise.vue'
import Store from './views/store.vue'
import Recruit from './views/recruit.vue'
import User from './views/user.vue'
import Privacy from './views/privacy.vue'
import Service from './views/service.vue'
import VueResource from "vue-resource"

Vue.config.productionTip = false

const routes = [
	{
		path: "/",
		component: Home
	},
	{
		path: "/index",
		component: Index
	},
	{
		path: "/indexH5",
		component: IndexH5
	},
	{
		path: "/about",
		component: About
	},
	{
		path: "/enterprise",
		component: Enterprise
	},
	{
		path: "/store",
		component: Store
	},
	{
		path: "/recruit",
		component: Recruit
	},
	{
		path: "/user",
		component: User
	},
	{
		path: "/privacy",
		component: Privacy
	},
	{
		path: "/service",
		component: Service
	}
]

const router = new VueRouter({
	routes
})

Vue.component('navigations', navigations)
Vue.component('tabbar', tabbar)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueResource)

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')